import { h } from 'vue'

export default {
    name: 'NExample',
    render() {
        return h('div', "Hello NUI!");
    }
}